import React from 'react'

import { actions } from 'react-redux-form'
import { connect } from 'react-redux'

import dotProp from 'dot-prop'
import { TimeInput } from "semantic-ui-calendar-react";

// Stores a plain "HH:mm" duration string in the form state — not an ISO
// datetime like SemanticDateWidget does. That is why this keeps its own
// state/redux mapping rather than reusing SemanticDateWidget's "duration"
// branch, which round-trips values through "YYYY-MM-DD HH:mm:ssZ".
class SemanticTimeDurationWidget extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      timeString: props.timeDuration || ''
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.timeDuration !== this.props.timeDuration) {
      this.setState({ timeString: this.props.timeDuration || '' })
    }
  }

  handleChange = (event, { value }) => {
    const { entityModel } = this.props
    this.setState({ timeString: value })
    this.props.dispatch(actions.change(entityModel, value))
  }

  render() {
    const { timeString } = this.state

    return (
      <TimeInput
        icon='time'
        timeFormat='24'
        closable
        value={timeString}
        onChange={this.handleChange}
        popupPosition='bottom center'
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  var entityModel = `${ownProps.model || ''}.${ownProps.id}`
  var timeDuration = dotProp.get(state, entityModel)
  return {
    timeDuration: timeDuration,
    entityModel: entityModel
  }
}

export default connect(mapStateToProps)(SemanticTimeDurationWidget);
